module.exports = __webpack_public_path__ + "static/media/anvisa.fd4ab8d3.png";